import React from "react";
import FilterbarError from "@radarly/components/error-boundary/filterbar";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";

export default function ErrorFilterbarLayout({ onReset }) {
  const locale = useCurrentUserLocale();
  return <FilterbarError locale={locale} onReset={onReset} />;
}
